import { Card } from "react-bootstrap";

export default function UserSummaryCard({
  user,
  title = "Resumen del usuario",
  fields,
  sections,
  cols = 3,
  hideEmpty = true,
  className = "",
  bare = false,
  showDividers = true,
  headerStyle = {},
  includeBodega = false,          // <— NUEVO
  bodegaTitle = "BODEGA",         // <— NUEVO
  bodegaCols = 2,                 // <— NUEVO
}) {
  const fullName =
    user?.nombre_completo ||
    [user?.nombre_usuario, user?.apellido_paterno, user?.apellido_materno]
      .filter(Boolean)
      .join(" ");

  const defaultFields = [
    { key: "nombre", label: "Nombre", render: () => fullName },
    { key: "usuario_red", label: "Usuario red" },
    { key: "ccven", label: "CVVEN" },
    { key: "correo", label: "Correo Izzi" },
    { key: "rfc", label: "RFC" },
    { key: "numero_vendedor", label: "No. Empleado" },
  ];

  const computeFields = (fArr) =>
    (fArr?.length ? fArr : defaultFields).map((f) => ({
      ...f,
      _value: f.render ? f.render(user) : user?.[f.key],
    }));

  const renderGrid = (fArr, colsLocal = cols) => {
    const col = Math.max(1, Math.min(12, Math.floor(12 / colsLocal)));
    return (
      <div className="row g-2">
        {computeFields(fArr).map((f) => {
          const empty =
            f._value === null ||
            f._value === undefined ||
            (typeof f._value === "string" && f._value.trim() === "");
          if (hideEmpty && empty) return null;
          return (
            <div className={`col-md-${col}`} key={f.key}>
              <div className="small text-muted">{f.label}</div>
              <div>{empty ? <span className="text-muted">—</span> : f._value}</div>
            </div>
          );
        })}
      </div>
    );
  };

  // --- Bodega: pintar solo si se pide y hay datos, y NO si ya están en fields/sections ---
  const hasBodegaData = !!(
    user?.bodega_distribuidor ||
    user?.bodega_nombre ||
    user?.bodega_almacen ||
    user?.bodega_region ||
    user?.bodega_direccion
  );

  const baseSections = sections?.length
    ? sections
    : [{ cols, fields }];

  const baseContainsBodega = baseSections.some(
    (sec) => (sec.fields || []).some((f) => String(f.key || "").startsWith("bodega_"))
  );

  const finalSections =
    includeBodega && hasBodegaData && !baseContainsBodega
      ? [
          ...baseSections,
          {
            title: bodegaTitle,
            cols: bodegaCols,
            fields: [
              { key: "bodega_distribuidor", label: "Distribuidor" },
              { key: "bodega_almacen",      label: "Almacén" },
              { key: "bodega_nombre",       label: "Bodega" },
              { key: "bodega_region",       label: "Región" },
              { key: "bodega_direccion",    label: "Dirección" },
            ],
          },
        ]
      : baseSections;
  // -------------------------------------------------------------------------------

  const Body = (
    <div className="py-3">
      {finalSections.length ? (
        finalSections.map((sec, i) => (
          <div key={i} className="mb-2">
            {sec.title && (
              <div className="small text-uppercase text-muted mb-1">{sec.title}</div>
            )}
            {renderGrid(sec.fields, sec.cols)}
            {showDividers && i < finalSections.length - 1 && <hr className="my-2" />}
          </div>
        ))
      ) : (
        renderGrid(fields)
      )}
    </div>
  );

  if (bare) return Body;

  return (
    <Card className={`mb-3 ${className}`}>
      <Card.Header className="py-2" style={headerStyle}>
        <strong>{title}</strong>
      </Card.Header>
      <Card.Body className="py-0">{Body}</Card.Body>
    </Card>
  );
}
